ixModuleRouting("impactx.prg2ctt", {
    '/prg2cttlist': {
        template: "<ixa-prg-ctt-mapping-list></ixa-prg-ctt-mapping-list>",
        process: "PRG2CTTMapping",
        workspace: "admin",
    },
    '/prg2ctt/:id': {
        template: "<ixa-prg-ctt-mapping-dialog></ixa-prg-ctt-mapping-dialog>",
        process: "PRG2CTTMapping",
        workspace: "admin",
    }
});